import type { FaireProductEntity } from "../../entity_types/product";

export const p_yqwqkzqc3e: FaireProductEntity = {
  token: "p_yqwqkzqc3e",
  type: "product",
  name: "Cocktail and Cards / Merry Little Cocktails Card",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/1de92f1d454917f27a527e92863332fa18ffffe6edd8765ea34c56c4a6f38bfa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed407cf0417c127a06809cd66126aa0abfd97ea7fb2368dd6f618d2b0c33fa4f.jpeg",
    "https://cdn.faire.com/fastly/c2a50bb2239d688634be9bfb2954a679770d01a0f61cd4de85be1ab3d98688fc.jpeg",
    "https://cdn.faire.com/fastly/ccfdf03b4d16a143295308dfbb64f3a2e8699b981046edcf83c35db77c7ee16b.jpeg",
  ],
  priceDollars: 4.25,
  description:
    'These premium greeting cards each contain a single serve craft cocktail.  You can now send a "Cocktail and a Card"! Instead of just sending your loved one a card they throw away after reading it...they have a cocktail too! \n\nOur cards are 5" x 7" printed on a premium matte card stock.  The cards have gold foil details and the envelopes are gold foil lined and self adhesive.  Each card comes on a dust jacket.\n\nNoble Mick\'s single serve craft cocktails are the perfect way to enjoy a craft cocktail anywhere, anytime.  At home or on the go there is no need to have all the ingredients to make your favorite cocktail.  \n\nNoble Mick\'s is NOT an infusion product these cocktails are ready to go when you are. Simply add H2O and Spirit, shake or stir with ice and enjoy. Never overly sweet or artificial tasting.  Seriously...our cocktails are delicious!\n\nAt Noble Mick\'s we use all natural fruit and vegetable powders, natural spices and flavors and pure cane sugar.  There is a real difference!',
  tags: [],
  msrpDollars: 8.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:07.482Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
